import React from 'react';

export const MCSAResults = () => {
    return (
        <iframe
            title="Results"
            src="/mcsa_htmls__TBD/results/report.html"
            style={{
                position: 'fixed',
                inset: 0,
                width: '100%',
                height: '100%',
                border: 'none',
            }}
        />
    );
};
